export default {
  name: 'tabs',

  props: {
    value: { type: Number, default: 0 },
    tabs: { type: Array, required: true },
  },

  data () {
    return {
      activeTabIdx: this.value,
    }
  },

  watch: {
    value (val) {
      this.activeTabIdx = val
    },

    activeTabIdx (val) {
      this.$emit('input', val)
    },

    /**
     * if the length of tabs changes, make sure `activeTabIdx` is still in a valid range
     */
    'tabs.length' () {
      if(this.activeTabIdx >= this.tabs.length) this.activeTabIdx = this.tabs.length - 1
    },
  },

  methods: {
    generateTabControls(h) {
      return this.tabs.map((name, idx) => {
        return h('n-button', {
          props: { inverted: this.activeTabIdx != idx, info: this.activeTabIdx == idx  },
          nativeOn: { click: () => this.activeTabIdx = idx },
        }, name)
      })
    },
  },

  render(h) {
    return h('section', {class: 'tabs elevation-1'}, [
      h('div', {class: 'tabs__controls scrollable scrollable-x grey lighten-4'}, this.generateTabControls(h)),
      h('div', {class: 'tabs__content'}, [this.$slots['tab-details'][this.activeTabIdx]]),      
    ])
  }
}
